import * as Yup from "yup";

export const validationSchema = Yup.object({
  date: Yup.string().required("Date is required"),
  personalMet: Yup.string().required("PersonalMet is required"),
  contactNo: Yup.string().required("Contact No is required"),
  designation: Yup.string().required("Designation is required"),
});
